import { Col, Row } from "antd";
import ClipboardCopy from "../../components/clipboard";

const GetStarted = ({ BrandToken }) => {
  return (
    <Row className="getstarted">
      <Col span={12}>
        <h6>Embed Web Widget (Classic)</h6>
        <p>
          Copy the following script and insert it into your website's HTML
          source code between the head tags.
          <br />
          This code must be inserted into root page it will display the widget on all pages.
        </p>

        <h1>Copy to Clipboard</h1>
        <ClipboardCopy BrandToken={BrandToken} />

        <h6>Embed Web Widget (Classic)</h6>
        <p>
          You can configure your widget to ensure that visitors you are talking
          to are your actual customers. <br />
          Set up visitor authentication or Learn more
        </p>
      </Col>
    </Row>
  );
};
export default GetStarted;  